export enum SignpostType {
    None = 0,
    PriceBoost = 1,
}
